<template>
  <Modal size="lg">
    <div class="modal-header">{{ "gift_card_order" | translate }}</div>
    <div class="modal-body">
      <div class="alert alert-warning" v-if="validationError">
        {{ validationError }}
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "vendor" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            v-model="giftCardOrderItem.vendor"
            :placeholder="'vendor' | translate"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "currency" | translate }}</div>
        <div class="col-9">
          <currency-picker
            class="form-control"
            v-model="giftCardOrderItem.currency"
          ></currency-picker>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "comment" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            v-model="giftCardOrderItem.comment"
            :placeholder="'comment' | translate"
          />
        </div>
      </div>

      <part-transaction-list
        :entity="'gift_card' | translate"
        :transactions="giftCardOrderItem.giftCards"
        :currency="giftCardOrderItem.currency"
      ></part-transaction-list>

      <part-transaction-list
        :entity="'payment' | translate"
        :transactions="giftCardOrderItem.payments"
        :currency="giftCardOrderItem.currency"
      ></part-transaction-list>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" @click="cancel">
        {{ "cancel" | translate }}
      </button>
      <button class="btn btn-primary" @click="save">
        {{ "save" | translate }}
      </button>
    </div>
  </Modal>
</template>

<script>
import PartTransactionList from "./PartTransactionList";
import _ from "lodash";
import almostEqual from "@/lib/almostEqual";

export default {
  props: ["editingItem"],
  data() {
    return {
      validationError: null,
      giftCardOrderItem: {
        vendor: null,
        currency: null,
        giftCards: [
          {
            account: null,
            amount: null,
            currency: null
          }
        ],
        payments: [
          {
            account: null,
            amount: null,
            currency: null
          }
        ],
        comment: null,
        timestamp: new Date().getTime()
      }
    };
  },
  created() {
    if (this.editingItem) {
      this.giftCardOrderItem = _.cloneDeep(this.editingItem);
    }
  },
  methods: {
    cancel() {
      this.$emit("dismiss");
    },
    save() {
      let item = this.giftCardOrderItem;
      this.assert(item.currency, "currency is required");
      this.assert(item.vendor, "vendor is required");
      this.assert(
        item.giftCards && item.giftCards.length,
        "gift card is required"
      );
      this.assert(item.payments && item.payments.length, "payment is required");
      this.assert(
        almostEqual(
          item.payments.reduce(
            (sum, p) => (p.amount ? p.amount + sum : sum),
            0
          ),
          item.giftCards.reduce(
            (sum, g) => (g.amount ? g.amount + sum : sum),
            0
          )
        ),
        "payment sum shall equal total gift card amount"
      );

      this.$emit("close", this.giftCardOrderItem);
    },

    assert(value, message) {
      if (!value) {
        this.validationError = message;
        throw new Error("validation failed: " + message);
      }
    }
  },

  components: {
    PartTransactionList
  }
};
</script>
